module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG89bbbef5e0cf9e9d2d061a45a5ca017b.89bbbef5.png";